import React, { useEffect, useState } from 'react'
import '../../../../Styles/Ht.css';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet, } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import { CommonReactTable } from '../../../CommonUtilities/CommonTable/CommonReactTable';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import moment from 'moment';
export default function AnsSheet() {

    const [showExamDate, setExamDate] = useState([]);
    function renderExams() {
        // let Url = config.url.DSC_Read_URL + "ans-sheet"
         let Url = config.url.DSC_Read_URL + "tet-ans-sheet"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                setExamDate(res?.data?.data);
            } else {
                setExamDate([])
            }
        })
    }
    useEffect(() => { renderExams() }, []);
    function getPostWise(data) {
        let Url = config.url.DSC_Read_URL + "tet-ans-sheet-log?paperId=" + data?.paper_id + "&mediumId=" + data?.medium_id;
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                window.open(data?.qp_html_path, '_blank');
            } else {
                Sweetalert(res?.data?.sdesc, 'warning')
            }
        })
    }
    const objColumns = [
        { Header: 'S.No.', accessor: (row, index) => index + 1 },
        { Header: () => 'Paper', accessor: 'subject_name' },
        {
            Header: () => 'Exam Date', accessor: 'exam_date', Cell: ({ row }) => (
                <>{row?.original?.exam_date}</>
            )
        }, { Header: () => 'Session', accessor: 'session' },
        { Header: () => 'Exam Center', accessor: 'tc_name' },

        {
            Header: () => 'Response Sheet', accessor: 'candidate_ans', Cell: ({ row }) => (
                <button className='btn btn-link' onClick={() => { getPostWise(row?.original) }}>
                    View
                </button>
            )
        },

    ]
    return (
        <div className="p-0 mt-4" >
            <CommonPageHeading heading='APTET-2026 Response Sheet' />

            {showExamDate?.length > 0 ? <CommonReactTable
                data={showExamDate}
                columns={objColumns}
                serachAlign='left'
                pagination='false'
                search='true'
                showFooter='false'
                filename='Report'
                paginationCount='All'
            /> : <div className='alert alert-warning'>NO DATA FOUND</div>}


        </div>)
}
